import React, { useEffect } from 'react'
import '../../../assets/styles/spge-cf-application.scss'
import { ApplyPcContent, ErrorPopup, Footer, ServiceList, SuccessPopupWithDownloadApp, TermsPopup, TermsPopup4CF } from '../../common'
import { SimpleSuccessPopup } from '../../common/SimpleSuccessPopup'
import {
  ApplicationHeader,
  BizNoField,
  BizNoTypeField,
  ConfirmPasswordField,
  IdField,
  OwnerNameField,
  OwnerPhoneNoField,
  PasswordField,
  ShopNameField,
  SubmitWrap,
  TermsWrap
} from './local-components/ApplicationComponents'
import useApplicationForm from './useApplicationForm'
import { bizNumFormat14Digit } from '../../tools'

const CustomerWrap = props => (
  <div className="customer_wrap">
    <p className="wrap_tit">
      사업자 정보<span className="color_r">*</span>
    </p>
    <BizNoTypeField {...props} />
    <BizNoField
      {...props}
      register={props.register}
      bizNoHelper={props.bizNoHelper}
      isBiznoValid={props.isBiznoValid}
      getApplyBizNoValid={props.getApplyBizNoValid}
      onChangeBizNo={props.onChangeBizNo}
      errors={props.errors}
    />
    <ShopNameField {...props} register={props.register} bizNoTrue={props.bizNoTrue} shop_name={props.errors.shop_name}></ShopNameField>
    <OwnerNameField
      {...props}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      ownerNameSetting={props.ownerNameSetting}
      owner_name={props.errors.owner_name}></OwnerNameField>
    <OwnerPhoneNoField
      {...props}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      ownerPhoneNoSetting={props.ownerPhoneNoSetting}
      errors={props.errors}></OwnerPhoneNoField>

    <IdField
      {...props}
      shop_idx={props.param.shop_idx}
      shopId={props.shopId}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      idSetting={props.idSetting}
      errors={props.errors}></IdField>
    <PasswordField
      {...props}
      shop_idx={props.param.shop_idx}
      shopPassword={props.shopPassword}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      passwordSetting={props.passwordSetting}
      errors={props.errors}></PasswordField>
    <ConfirmPasswordField
      {...props}
      shop_idx={props.param.shop_idx}
      shopConfirmPassword={props.shopConfirmPassword}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      confirmPassword={props.confirmPassword}
      errors={props.errors}></ConfirmPasswordField>
  </div>
)

const SuccessPopupSponge2Franchise = ({ open }) => {
  return (
    <SimpleSuccessPopup open={open}>
      프랜차이즈 정보 제공 동의서가
      <br />
      발송 되었습니다!
      <br />
      <span
        style={{
          fontWeight: '400',
          lineHeight: '36px',
          textAlign: 'center',
          fontSize: '18px',
          display: 'block',
          marginTop: '12px',
          marginBottom: '-36px'
        }}>
        정보 제공에 동의하셔야 전환이 완료될 수 있습니다.
      </span>
    </SimpleSuccessPopup>
  )
}

const ApplicationSpongeCF = () => {
  const isSpgeCF = true
  const af = useApplicationForm({ isSpgeCF })
  const {
    location,
    param,
    formRef,
    different_customer_sign_ref,
    different_account_sign_ref,
    managerName,
    serviceNum,
    setServiceNum,
    setServiceInfo,
    serviceInfo,
    serviceBoxInputEvh,
    serviceHelper,
    setServiceHelper,
    cost,
    setCost,
    successPopupState,
    errorPopupState,
    setErrorPopupState,
    errorPopupMessage,
    btnState,
    serviceStartDt,
    setServiceStartDt,
    withdrawalDt,
    setWithdrawalDt,
    shopId,
    shopPassword,
    shopConfirmPassword,
    reSignup,

    // selectList,
    differentCustomerIsSigned,
    setDifferentCustomerIsSigned,
    differentCustomerHelper,
    setDifferentCustomerHelper,
    differentAccountIsSigned,
    setDifferentAccountIsSigned,
    differentAccountHelper,
    setDifferentAccountHelper,
    register,
    handleSubmit,
    bizNoTrue,
    freeMonthYn,
    bizNoHelper,
    bizNo,
    isBiznoValid,
    getApplyBizNoValid,
    onChangeBizNo,
    onSubmit,
    ownerNameSetting,
    ownerPhoneNoSetting,
    // accountNameSetting,
    idSetting,
    passwordSetting,
    confirmPassword,
    diffApplyCustomerCheck,
    differentApplyCustomerCheck,
    differentAccountCheck,
    termsPopupOpen,
    termsPopupClose,
    errors,
    notEditInfo,
    isSpge2Frch,
    cfExists
  } = af

  useEffect(() => {
    if (typeof window !== 'undefined' && formRef?.current) {
      const sp = new URLSearchParams(location.search)
      const v = sp.get('bizNo')
      if (v) {
        const biz_no = formRef.current.querySelector('#biz_no')
        if (biz_no) {
          biz_no.value = bizNumFormat14Digit(v)
          formRef.current.querySelector('#biz_no_btn').click()
          biz_no.focus()
        }
      }
    }
  }, [formRef])

  return (
    <div className={'Application SubPages'}>
      <div className={'application_wrap ' + isSpgeCF ? 'spge-cf-application' : ''}>
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div className={successPopupState || errorPopupState ? 'application_sheet notScroll' : 'application_sheet 2'} ref={formRef}>
          <ApplicationHeader {...af} location={location} managerName={managerName} />
          <form className="application_form_wrap" onSubmit={handleSubmit(onSubmit)}>
            <CustomerWrap
              {...af}
              param={param}
              shopId={shopId}
              shopPassword={shopPassword}
              shopConfirmPassword={shopConfirmPassword}
              reSignup={reSignup}
              register={register}
              bizNoTrue={bizNoTrue}
              bizNoHelper={bizNoHelper}
              isBiznoValid={isBiznoValid}
              getApplyBizNoValid={getApplyBizNoValid}
              onChangeBizNo={onChangeBizNo}
              ownerNameSetting={ownerNameSetting}
              ownerPhoneNoSetting={ownerPhoneNoSetting}
              idSetting={idSetting}
              passwordSetting={passwordSetting}
              confirmPassword={confirmPassword}
              errors={errors}></CustomerWrap>
            {notEditInfo ? (
              <div style={{ height: '17px' }}></div>
            ) : (
              <>
                <ServiceList
                  isSpgeCF={isSpgeCF}
                  register={register}
                  cost={cost}
                  freeMonthYn={freeMonthYn}
                  serviceBoxInputEvh={serviceBoxInputEvh}
                  serviceInfo={serviceInfo}
                  setServiceInfo={setServiceInfo}
                  setServiceHelper={setServiceHelper}
                  serviceHelper={serviceHelper}
                  setCost={setCost}
                  serviceNum={serviceNum}
                  setServiceNum={setServiceNum}
                  setServiceStartDt={setServiceStartDt}
                  setWithdrawalDt={setWithdrawalDt}
                  withdrawalDt={withdrawalDt}
                  serviceStartDt={serviceStartDt}
                  bizNo={bizNo}
                />

                <TermsWrap
                  {...af}
                  different_customer_sign_ref={different_customer_sign_ref}
                  different_account_sign_ref={different_account_sign_ref}
                  differentCustomerIsSigned={differentCustomerIsSigned}
                  setDifferentCustomerIsSigned={setDifferentCustomerIsSigned}
                  differentCustomerHelper={differentCustomerHelper}
                  setDifferentCustomerHelper={setDifferentCustomerHelper}
                  differentAccountIsSigned={differentAccountIsSigned}
                  setDifferentAccountIsSigned={setDifferentAccountIsSigned}
                  differentAccountHelper={differentAccountHelper}
                  setDifferentAccountHelper={setDifferentAccountHelper}
                  register={register}
                  diffApplyCustomerCheck={diffApplyCustomerCheck}
                  differentApplyCustomerCheck={differentApplyCustomerCheck}
                  differentAccountCheck={differentAccountCheck}
                  termsPopupOpen={termsPopupOpen}
                  errors={errors}
                />
              </>
            )}
            <SubmitWrap {...af} btnState={btnState} serviceStartDt={serviceStartDt} withdrawalDt={withdrawalDt} />
          </form>

          <Footer />
          <TermsPopup termsPopupClose={termsPopupClose} capture={false} />
          <TermsPopup4CF franchiseName={af.platformName} termsPopupClose={af.termsPopupClose4CF} capture={false} />
          <SuccessPopupWithDownloadApp {...af} open={successPopupState && !isSpge2Frch} />
          <SuccessPopupSponge2Franchise open={successPopupState && isSpge2Frch} />
          <ErrorPopup open={errorPopupState} setErrorPopupState={setErrorPopupState} errorPopupMessage={errorPopupMessage} />
        </div>
      </div>
    </div>
  )
}
export { ApplicationSpongeCF }
